import React from 'react'
import { Section, Grid } from 'inno-components'
import { css } from 'aphrodite'
import Helmet from 'react-helmet'
import { withNamespaces } from 'react-i18next'

import Classes from '../../styles/classes'

const GarantieEtProcessus = ({ t }) => (
  <React.Fragment>
    <Helmet
      title={t('head.title')}
      meta={[
        {
          name: 'description',
          content: t('head.meta-description')
        }
      ]}
    />
    <Section className={css(Classes.section)}>
      <Grid stackable>
        <Grid.Row>
          <Grid.Column width={16}>
            <p
              className={css(Classes.paragraph)}
              dangerouslySetInnerHTML={{
                __html: t('paragraphes.0')
              }}
            />
            <p
              className={css(Classes.paragraph)}
              dangerouslySetInnerHTML={{
                __html: t('paragraphes.1')
              }}
            />
            <p
              className={css(Classes.paragraph)}
              dangerouslySetInnerHTML={{
                __html: t('paragraphes.2')
              }}
            />
            <p
              className={css(Classes.paragraph)}
              dangerouslySetInnerHTML={{
                __html: t('paragraphes.3')
              }}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Section>
  </React.Fragment>
)

export default withNamespaces('garantie-et-processus-de-recyclage')(GarantieEtProcessus)
